// Standalone "service closed" notice. Rendered in place of the whole app so every
// visitor to app.crewlinker.com sees the same message regardless of the URL they
// land on. Intentionally self-contained: no router, Relay, auth or network calls,
// and inline styles so it does not depend on Tailwind class purging.
const ClosedNotice = () => (
  <main
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      backgroundColor: '#fcfcfc',
      color: '#0a2540',
      textAlign: 'center',
    }}
  >
    <div style={{ maxWidth: '560px' }}>
      <p
        style={{
          fontSize: '14px',
          fontWeight: 600,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: '#2a6ff5',
          margin: '0 0 16px',
        }}
      >
        Crewlinker
      </p>
      <h1 style={{ fontSize: '32px', fontWeight: 700, lineHeight: 1.2, margin: '0 0 16px' }}>Crewlinker has closed</h1>
      <p style={{ fontSize: '18px', lineHeight: 1.6, color: '#52617a', margin: '0 0 24px' }}>
        Thank you to everyone who was part of our journey. The Crewlinker platform is no longer available.
      </p>
      <p style={{ fontSize: '15px', lineHeight: 1.6, color: '#52617a', margin: 0 }}>
        For any questions, you can reach us at{' '}
        <a href="mailto:hello@crewlinker.com" style={{ color: '#2a6ff5', fontWeight: 600, textDecoration: 'none' }}>
          hello@crewlinker.com
        </a>
        .
      </p>
    </div>
  </main>
);

export default ClosedNotice;
